<template>
  <div class="form-option-card-item w-100 d-flex flex-column">
    <label for="options"> Optionen </label>
    <!-- <div
      class="card-option-wrapper w-100 d-flex flex-column justify-content-center align-items-center"
    > -->
    <draggable
      class="card-option-wrapper w-100 d-flex flex-column justify-content-center align-items-center"
      v-model="element.options"
      ghost-class="drag-ghost"
      draggable=".card-option"
      handle=".drag-handler"
      tag="div"
      :move="onDragMove"
      @start="onDragStart"
      @end="onDragEnd"
    >
      <div
        class="card-option w-100 d-flex flex-column position-relative"
        v-for="(option, index) in element.options"
        :key="index"
        :class="getDropzoneClass(index)"
      >
        <img class="drag-handler" src="@/assets/img/drag-icon.svg" />
        <div class="row-item">
          <div v-if="isShowCheckField" class="row-left">
            <input
              :type="element.type"
              :name="element.name"
              :value="option.label"
              :checked="option.checked"
              :disabled="!isUserHasAccess || element.settings.disabled"
              @change="onHandleChange(option)"
            />
          </div>
          <div
            class="row-right d-flex align-items-center justify-content-start gap-3"
          >
            <label :for="`label-${index}`">Titel </label>
            <input
              :class="{ invalid: isInvalidOption(option.label, 'label') }"
              type="text"
              :id="`label-${index}`"
              placeholder="Titel"
              v-model.trim="option.label"
              :disabled="!isUserHasAccess"
              @input="onHandleOptionInput($event, index, 'option')"
              @invalid="onHandleInvalid"
            />
          </div>
        </div>
        <div class="row-item">
          <div v-if="isShowCheckField" class="row-left"></div>
          <div
            class="row-right d-flex align-items-center justify-content-start gap-3"
          >
            <label :for="`value-${index}`">Wert </label>
            <input
              :class="{ invalid: isInvalidOption(option.value, 'value') }"
              type="text"
              :id="`value-${index}`"
              placeholder="Wert"
              v-model.trim="option.value"
              :disabled="!isUserHasAccess"
              required
              @input="onHandleOptionInput($event, index, 'value')"
              @invalid="onHandleInvalid"
            />
          </div>
        </div>
        <div v-if="isShowOptionImage" class="row-item">
          <div class="row-left"></div>
          <div class="row-right">
            <div class="option-img-wrapper position-relative">
              <button
                v-if="!option.img"
                @click.prevent="toggleIconPicker(index)"
                :disable="!isUserHasAccess"
              >
                <img src="@/assets/img/empty-image-icon.svg" />
              </button>
              <img v-if="option.img" class="option-img" :src="option.img" />
              <div
                v-if="option.img"
                @click="onRemoveIcon(index)"
                class="remove-icon"
              >
                <i class="fa fa-times"></i>
              </div>
            </div>

            <IconPicker
              v-if="index === clickIconPickerIdx"
              v-click-outside="toggleIconPicker"
              :displayIconPickerSections="['icon', 'illustration', 'custom']"
              :element="option"
              @updateUrl="onUpdateUrl"
              @updateLinkType="onUpdateLinkType"
            />
          </div>
        </div>
        <div class="row-item" v-if="isShowoptionDescription">
          <div class="row-left"></div>
          <div class="row-right">
            <textarea
              :id="`description-${index}-0`"
              placeholder="Beschreibung"
              v-model="option.description"
              :disabled="!isUserHasAccess"
            />
          </div>
        </div>
        <div class="row-item" v-if="element.settings.isOptionLinked">
          <div class="row-left"></div>
          <div class="row-right">
            <div class="link-details-header" @click="toggleLinkDetails(index)">
              <span class="caption">Link details</span>
              <img
                class="collapse-toggle"
                :class="{ open: linkDetailsOpen[index] }"
                src="@/assets/img/angle-arrow-down.svg"
                alt="toggle"
              />
            </div>
            <b-collapse v-model="linkDetailsOpen[index]">
              <div class="custom-link-settings" v-if="option.linkDetails">
                <label class="caption">Bezeichnung </label>
                <input
                  v-model="option.linkDetails.label"
                  type="text"
                  :disabled="!isUserHasAccess"
                />
              </div>
              <div class="custom-link-settings" v-if="option.linkDetails">
                <label class="caption">Verknüpfung </label>
                <input
                  v-model="option.linkDetails.link"
                  type="text"
                  :disabled="!isUserHasAccess"
                />
              </div>
            </b-collapse>
          </div>
        </div>
        <OptionCardModalSettingsPanel
          v-if="element.settings.appearance === 'card'"
          :option="option"
          :element="element"
          :isUserHasAccess="isUserHasAccess"
        />
        <div class="delete-option">
          <img
            src="@/assets/img/form-settings-trash.svg"
            @click="removeOption(option)"
          />
        </div>
      </div>
    </draggable>
    <!-- </div> -->
    <div class="add-more-option">
      <span
        class="add-more-option-button d-flex align-items-center justify-content-center"
        @click="addNewOption"
        :class="{ disabled: !isUserHasAccess }"
      >
        <img src="@/assets/img/plus-icon.svg" />
      </span>
    </div>
  </div>
</template>

<script>
import { createUnique } from '@/utils/helpers/FormBuilderHelper.js';
import { showInputInvalidCustomMessage } from '@/utils/helpers';
import IconPicker from '@/components/widgets/IconPicker.vue';
import OptionCardModalSettingsPanel from './OptionCardModalSettingsPanel.vue';
import draggable from 'vuedraggable';

export default {
  name: 'OptionCardEditElement',
  data() {
    return {
      clickIconPickerIdx: null,
      isShowAddOptionInput: false,
      inValid: { optionIndex: null, valueIndex: null },
      linkDetailsOpen: {},
      draggedIndex: null,
      dragOverIndex: null,
      dragPosition: null,
      scrolling: false,
      scrollDirection: 0,
    };
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
    isUserHasAccess: { type: Boolean, default: true },
  },
  methods: {
    toggleLinkDetails(index) {
      this.$set(this.linkDetailsOpen, index, !this.linkDetailsOpen[index]);
    },
    ensureOptionLinkDetails(option) {
      if (!option) return;
      const position =
        this.element?.options?.[0]?.linkDetails?.position != null
          ? this.element.options[0].linkDetails.position
          : 'left';
      if (!option.linkDetails) {
        this.$set(option, 'linkDetails', {
          label: 'Link',
          link: '',
          position,
        });
      } else if (!option.linkDetails.position) {
        this.$set(option.linkDetails, 'position', position);
      }
    },
    ensureAllOptionLinkDetails() {
      if (!Array.isArray(this.element?.options)) return;
      this.element.options.forEach((option) => {
        this.ensureOptionLinkDetails(option);
      });
    },
    onHandleChange(selectedOption) {
      if (this.element.type === 'radio') {
        this.element.options.forEach((option) => {
          option.checked = option === selectedOption;
        });
        this.element.value = selectedOption.value;
      } else if (this.element.type === 'checkbox') {
        selectedOption.checked = !selectedOption.checked;
        if (selectedOption.checked)
          this.element.value.push(selectedOption.value);
        else
          this.element.value = this.element.value.filter(
            (e) => e !== selectedOption.value
          );
      }
    },
    toggleIconPicker(index) {
      this.clickIconPickerIdx = index;
    },
    onUpdateUrl(icon) {
      this.$set(this.element.options[this.clickIconPickerIdx], 'img', icon);
    },
    onUpdateLinkType(linkType) {
      this.$set(
        this.element.options[this.clickIconPickerIdx],
        'linkType',
        linkType
      );
    },
    onRemoveIcon(index) {
      this.$set(this.element.options[index], 'img', '');
      this.$set(this.element.options[index], 'linkType', null);
    },
    removeOption(option) {
      if (!this.isUserHasAccess) return;

      this.element.options = this.element.options.filter((el) => {
        return el != option;
      });
      if (this.element.type === 'checkbox') {
        this.element.settings.max = this.element.options.length;
        this.element.value = this.element.options
          .filter((option) => option.checked)
          .map((option) => option.value);
      } else if (this.element.type === 'radio' && option?.checked) {
        if (this.element.options?.length) {
          this.element.options[0].checked = true;
          this.element.value = this.element.options[0].value;
        } else {
          this.element.value = '';
        }
      }
    },
    addNewOption() {
      if (!this.isUserHasAccess) return;
      const option = {
        label: '',
        value: '',
        description: null,
        img: '',
        linkType: null,
        checked: !this.element.options.length,
      };
      if (this.element.settings.isOptionLinked) {
        this.ensureOptionLinkDetails(option);
      }
      option.value = createUnique(
        this.element.options.map((op) => op.value),
        'Wert1'
      );
      if (!this.element.options.length) {
        this.element.value = option.value;
      }
      if (this.element.settings.appearance === 'card') {
        this.$set(option, 'modalConfig', {
          jsonContent: null,
          htmlContent: null,
          margin: 'small-margin',
          modalLink: 'Mehr Infos',
        });
      }
      this.element.options.push(option);
    },
    onHandleOptionInput(event, index, type) {
      const inputValue = event.target.value;
      if (type === 'option') {
        const isOptionLabelExist =
          this.element.options.filter(
            (option, optionIndex) =>
              option.label &&
              option.label === inputValue.trim() &&
              optionIndex != index
          ).length > 0;

        if (isOptionLabelExist) {
          this.inValid.optionIndex = index;
        } else {
          this.inValid.optionIndex = null;
        }
      } else if (type === 'value') {
        const isOptionValueExist =
          this.element.options.filter(
            (option, optionIndex) =>
              option.value === inputValue.trim() && optionIndex != index
          ).length > 0;

        if (isOptionValueExist) {
          this.inValid.valueIndex = index;
        } else {
          if (inputValue.trim() === '') {
            this.inValid.valueIndex = index;
          } else {
            this.inValid.valueIndex = null;
          }
        }
        if (this.element.options[index].checked) {
          if (this.element.type === 'radio') this.element.value = inputValue;
          else if (this.element.type === 'checkbox')
            this.element.value = this.element.options
              .filter((option) => option.checked)
              .map((option) => option.value);
        }
      }
      showInputInvalidCustomMessage(event);
    },
    isInvalidOption(value, type) {
      const trimmedValue = value.trim();
      const isEmpty = trimmedValue.length === 0;

      if (isEmpty) return type === 'value';

      const duplicates = this.element.options.filter((option) => {
        if (type === 'label') return option.label === trimmedValue;
        if (type === 'value') return option.value === trimmedValue;
        return false;
      });

      return duplicates.length > 1;
    },
    onHandleInvalid(event) {
      showInputInvalidCustomMessage(event);
    },
    onDragStart(evt) {
      this.draggedIndex =
        evt.oldDraggableIndex != null ? evt.oldDraggableIndex : evt.oldIndex;
    },
    getDropzoneClass(index) {
      const isAdjacent =
        this.draggedIndex === index ||
        (Math.abs(this.draggedIndex - index) === 1 &&
          ((this.dragPosition === 'top' && this.draggedIndex < index) ||
            (this.dragPosition === 'bottom' && this.draggedIndex > index)));

      if (isAdjacent) return {};
      return {
        'dropzone-top':
          this.dragOverIndex === index && this.dragPosition === 'top',
        'dropzone-bottom':
          this.dragOverIndex === index && this.dragPosition === 'bottom',
      };
    },
    scrollHandler(evt) {
      const scrollContainer = document.querySelector(
        '.sidebar-content.fancy-scroll'
      );

      if (!scrollContainer) return;

      const box = scrollContainer.getBoundingClientRect();
      const mouseY = evt.originalEvent.clientY;
      const threshold = 50;

      if (mouseY < box.top + threshold) {
        this.scrollDirection = -1; // scroll up
        this.startSmoothScroll(scrollContainer);
      } else if (mouseY > box.bottom - threshold) {
        this.scrollDirection = 1; // scroll down
        this.startSmoothScroll(scrollContainer);
      } else {
        this.scrollDirection = 0; // stop
      }
    },
    startSmoothScroll(scrollContainer) {
      if (this.scrolling) return;
      this.scrolling = true;

      const step = () => {
        if (this.scrollDirection === 0) {
          this.scrolling = false;
          return;
        }

        scrollContainer.scrollTop += this.scrollDirection * 6;

        requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    },
    onDragMove(evt) {
      this.scrollHandler(evt);
      const target = evt.related;
      if (!target) return false;

      const targetRect = target.getBoundingClientRect();
      const halfway = targetRect.top + targetRect.height / 2;
      const clientY = evt.originalEvent.clientY;

      this.dragOverIndex = evt.relatedContext.index;
      this.dragPosition = clientY < halfway ? 'top' : 'bottom';

      return false;
    },
    onDragEnd(evt) {
      if (this.dragOverIndex === null) return;

      const fromIndex = evt.oldIndex;
      const toIndex =
        this.dragPosition === 'top'
          ? this.dragOverIndex
          : this.dragOverIndex + 1;

      const movedItem = this.element.options.splice(fromIndex, 1)[0];
      this.element.options.splice(toIndex, 0, movedItem);

      this.dragOverIndex = null;
      this.dragPosition = null;
      this.draggedIndex = null;
    },
  },
  computed: {
    isShowOptionImage() {
      return this.element.settings.appearance === 'card';
    },
    isShowoptionDescription() {
      return (
        this.element.settings.isShowTitleAndDescription &&
        this.element.settings.appearance === 'card'
      );
    },
    isShowCheckField() {
      return ['radio', 'checkbox'].includes(this.element.type);
    },
  },

  created() {
    if (this.element.settings.isOptionLinked) {
      this.ensureAllOptionLinkDetails();
    }
  },
  watch: {
    'element.settings.isOptionLinked'(next) {
      if (next) this.ensureAllOptionLinkDetails();
    },
  },
  components: {
    IconPicker,
    OptionCardModalSettingsPanel,
    draggable,
  },
};
</script>

<style scoped>
.form-option-card-item {
  gap: 8px;
  font-family: OpenSans-Regular;
}
.form-option-card-item .card-option-wrapper .row-right textarea,
.form-option-card-item .card-option-wrapper .row-right input,
.form-option-card-item label {
  font-family: 'OpenSans-Regular';
  color: #484e5e;
  font-size: 13px;
  line-height: 36px;
  letter-spacing: -0.02em;
  font-weight: 400;
}
.form-option-card-item .card-option-wrapper {
  gap: 18px;
}
.form-option-card-item .card-option-wrapper .dropzone-top::before,
.form-option-card-item .card-option-wrapper .dropzone-bottom::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 3px;
  background: #86c3f4;
}

.form-option-card-item .card-option-wrapper .dropzone-top::before {
  top: -10.5px;
}

.form-option-card-item .card-option-wrapper .dropzone-bottom::after {
  bottom: -10.5px;
}

.form-option-card-item .card-option-wrapper .card-option label {
  font-family: 'OpenSans-SemiBold';
  font-weight: 600;
  width: 50px;
  color: #464d5d;
  line-height: 36px;
}

.form-option-card-item .card-option-wrapper .card-option {
  gap: 8px;
  position: relative;
  user-select: none;
  padding-left: 20px;
}
.form-option-card-item .card-option-wrapper .card-option .drag-handler {
  position: absolute;
  top: 6px;
  left: 0px;
  visibility: hidden;
  cursor: pointer;
}
.form-option-card-item .card-option-wrapper .card-option:hover .drag-handler {
  visibility: visible;
}
.form-option-card-item .card-option-wrapper .row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.form-option-card-item .card-option-wrapper .row-left {
  width: 50px;
  max-width: 100%;
  padding-left: 5px;
}
.form-option-card-item .card-option-wrapper .row-left:has(img) {
  height: 45px;
}
.form-option-card-item .card-option-wrapper .row-left input {
  width: 17px;
  height: 17px;
}

.form-option-card-item .card-option-wrapper .row-left input:focus {
  outline: none;
  box-shadow: none;
}
.form-option-card-item .card-option-wrapper .option-img-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 2px;
}
.form-option-card-item .card-option-wrapper .option-img-wrapper .option-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.form-option-card-item .card-option-wrapper .option-img-wrapper .remove-icon {
  position: absolute;
  top: -5px;
  right: -5px;
  background: black;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  text-align: center;
  color: white;
  cursor: pointer;
  display: none;
  transition: 0.5s ease all;
}
.form-option-card-item .card-option-wrapper .option-img-wrapper .remove-icon i {
  font-size: smaller;
}

.form-option-card-item .option-img-wrapper:hover .remove-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-option-card-item .card-option-wrapper .row-right {
  width: calc(100% - 90px);
  max-width: 100%;
  position: relative;
}
.form-option-card-item .card-option-wrapper .row-right textarea,
.form-option-card-item .card-option-wrapper .row-right input {
  font-size: 13px;
  font-weight: 400;
  color: #484e5e;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-family: 'OpenSans-Regular';
}

.form-option-card-item .card-option-wrapper .row-right textarea {
  height: 100px;
  width: 100%;
  resize: none;
  padding: 15px;
}

.form-option-card-item .card-option-wrapper .row-right input {
  height: 36px;
  width: 100%;
  padding: 0 20px;
  line-height: 36px;
}

.form-option-card-item .link-details-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  cursor: pointer;
  user-select: none;
}
.form-option-card-item .link-details-header .caption {
  font-family: 'OpenSans-Regular';
  font-size: 13px;
  font-weight: 400;
  color: #484e5e;
  letter-spacing: -0.02em;
  line-height: 36px;
}
.form-option-card-item .link-details-header .collapse-toggle {
  width: 12px;
  height: 12px;
  transition: transform 0.1s ease-in-out;
}
.form-option-card-item .link-details-header .collapse-toggle.open {
  transform: rotate(180deg);
}

.form-option-card-item .custom-link-settings input,
.form-option-card-item .custom-link-settings .caption {
  font-family: 'OpenSans-Regular';
  font-size: 13px;
  font-weight: 400;
  color: #484e5e;
  letter-spacing: -0.02em;
  line-height: 36px;
}
.form-option-card-item .custom-link-settings input {
  width: calc(100% - 10px);
  color: #111111;
  border: 0.7px solid #d9dbdc;
  border-radius: 2px;
  padding: 0 15px;
  height: 36px;
}

.form-option-card-item .card-option-wrapper .row-right button {
  height: 45px;
  margin: 0px;
  width: 45px;
  letter-spacing: -0.02em;
  cursor: pointer;

  background-color: transparent;
  border: none;
  border-radius: 8px;
}
.form-option-card-item .card-option-wrapper .row-right textarea {
  height: 100px;
  width: 100%;
  resize: none;
  padding: 15px;
  line-height: unset;
}

.form-option-card-item input[type='text']:focus {
  outline: none;
}
.form-option-card-item input[type='text'].invalid {
  outline: 1px solid #ff0000;
  color: #ff0000 !important;
  background-color: #ff00004a;
}

.form-option-card-item .delete-option {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  position: absolute;
  top: 32px;
  right: 0;
  border-radius: 3px;
}
.form-option-card-item .delete-option:hover {
  opacity: 0.7;
}

.form-option-card-item ::v-deep .icon-picker-widget {
  right: 0;
}
.form-option-card-item .add-more-option {
  padding: 0 15px;
}
.form-option-card-item .add-more-option .add-more-option-button {
  padding: 4px;
  margin: 20px auto 22px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 3px;
}
.form-option-card-item .add-more-option .add-more-option-button:hover {
  opacity: 0.7;
}
.form-option-card-item .add-more-option .add-more-option-button.disabled {
  cursor: default;
  opacity: 0.6;
}
.form-option-card-item input:-webkit-autofill {
  box-shadow: 0 0 0 1000px white inset !important;
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
</style>
